import Vue from 'vue';
import axios from 'axios';
import moment from 'moment';

export default {
  name: 'vanishingTableSelection',
  components: {
    DataGridComp: require('./datagrid.vue').default,
  },
  props: {
    parent: {
      type: Object,
      required: true
    },
    dataSourceFun: {
      type: Function,
      required: true
    },
    dataSource: {
      type: String,
      required: true
    },
    config: {
      type: Object,
      required: true
    },
    selection: {
      type: Function
    },
    label: {
      type: String,
      default: ''
    },
    displayField: {
      type: String,
      default: ''
    },
    valueField: {
      type: String,
      default: ''
    },
    parentModel: {
      type: String,
      default: ''
    }
  },
  data: function () {
    return {
      showDialog: false,
      selectedObj: null,
      displayedValue: ''
    }
  },
  created() {
    
  },
  watch: {

  },
  methods: {
    pageChange(pInfo) {
      if (this.config.pageOptions.page == pInfo.pageNumber && this.config.pageOptions.pageSize == pInfo.pageSize)
        return;

      this.config.pageOptions.page = pInfo.pageNumber;
      this.config.pageOptions.pageSize = pInfo.pageSize;

      this.dataSourceFun(this.config.pageOptions);
    },
    rowSelected(info) {
      this.selectedObj = info.data;
      this.displayedValue = this.displayField == '' ? '' : this.selectedObj[this.displayField];
      this.fillParentModel();
      this.showDialog = false;

      if (this.selection)
        this.selection(this.selectedObj);
    },
    fillParentModel() {
      if (this.parentModel == '')
        return;

      if (this.parentModel.includes('.')) {
        const arr = this.parentModel.split('.');

        if (arr.length == 1)
          this.parent[arr[0]] = this.selectedObj[this.valueField];
        else if (arr.length == 2)
          this.parent[arr[0]][arr[1]] = this.selectedObj[this.valueField];
        else if (arr.length == 3)
          this.parent[arr[0]][arr[1]][arr[2]] = this.selectedObj[this.valueField];
        else if (arr.length == 4)
          this.parent[arr[0]][arr[1]][arr[2]][arr[3]] = this.selectedObj[this.valueField];
        else if (arr.length == 5)
          this.parent[arr[0]][arr[1]][arr[2]][arr[3]][arr[4]] = this.selectedObj[this.valueField];
      } else {
        this.parent[this.parentModel] = this.selectedObj[this.valueField];
      }
    }
  }
}
